import SVG from "../../SVG"
import {Tooltip} from "react-tooltip"
export default function Back() {
  return (
    <div className="h-full px-3 flex items-center justify-center border-r border-r-zi-border-light dark:border-r-zi-border-dark">
      <a
        onClick={() => window.history.back()}
        data-tooltip-id="backTooltip"
        data-tooltip-content="بازگشت"
      >
        <SVG name="back" classname="size-5 cursor-pointer stroke-zi-blue-dark dark:stroke-white" />
      </a>

      <Tooltip
        id="backTooltip"
        place="bottom"
        className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-zi-blue-dark !rounded-lg"
      />
    </div>
  )
}